import { SearchFilterType } from "@/components/search/types";

export const defaultSearchFilters: SearchFilterType = [
  {
    id: "Search_Text",
    type: "input",
    label: "Filter by card text",
    placeholder: "Filter by card text",
  },
  {
    id: "Search_FlavorText",
    type: "input",
    label: "Filter by flavor text",
    placeholder: "Filter by flavor text",
  },
  {
    id: "Type",
    type: "multiselect",
    label: "Filter by card type",
    placeholder: "Select card types",
    options: [
      "Ally",
      "Attachment",
      "Contract",
      "Event",
      "Hero",
      "Playersidequest",
      "Treasure",
      "Campaign",
      "Cave",
      "Encountersidequest",
      "Enemy",
      "Location",
      "Objective",
      "Objectiveally",
      "Objectivehero",
      "Objectivelocation",
      "Quest",
      "Setup",
      "Shipenemy",
      "Shipobjective",
      "Treachery",
    ],
  },
  {
    id: "Sphere",
    type: "multiselect",
    label: "Filter by card sphere",
    placeholder: "Select card spheres",
    options: [
      "Leadership",
      "Lore",
      "Spirit",
      "Tactics",
      "Neutral",
      "Baggins",
      "Fellowship",
    ],
  },
  {
    id: "Attack",
    type: "range",
    label: "Filter by attack",
    min: 0,
    max: 10,
    special: [254, 255],
  },
  {
    id: "Defense",
    type: "range",
    label: "Filter by defense",
    min: 0,
    max: 10,
    special: [254, 255],
  },
  {
    id: "Willpower",
    type: "range",
    label: "Filter by willpower",
    min: 0,
    max: 10,
    special: [254, 255],
  },
  {
    id: "HitPoints",
    type: "range",
    label: "Filter by hit points",
    min: 0,
    max: 10,
    special: [253, 254, 255],
  },
  {
    id: "ResourceCost",
    type: "range",
    label: "Filter by resource cost",
    min: 0,
    max: 6,
    special: [254, 255],
  },
  {
    id: "ThreatCost",
    type: "range",
    label: "Filter by threat cost",
    min: 0,
    max: 6,
    special: [254, 255],
  },
];

export default defaultSearchFilters;
